<template>
  <div v-if="$route.path !== '/'" class="bg-h-primary-500 px-4">
    <div class="w-full py-24 container mx-auto">
      <div class="flex flex-wrap items-center justify-center gap-10">
        <Logo class="grayscale invert brightness-0" />
        <p class="text-white text-[15px] w-fit text-center flex justify-center">
          {{
            $t("labels.generic", {
              pt: "Plataforma de educação adaptativa, com uso de inteligência artificial.",
              en: "Adaptive education platform, using artificial intelligence, in which students are trained, according to their availability and learning conditions.",
            })
          }}
        </p>
        <div
          class="flex justify-center flex-wrap gap-5 lg:justify-end items-center w-fit"
        >
          <div
            v-if="partners?.length !== 0"
            class="flex items-center gap-8 justify-end"
          >
            <img
              v-for="(img, index) in partners"
              :key="index"
              :src="getFileUrl(img)"
              class="w-fit h-8"
              loading="lazy"
            />
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="flex w-full justify-center items-center bg-h-primary-700">
    <p class="text-white py-10 text-md">
      © {{ todayYear }}.
      {{
        $t("labels.generic", {
          pt: "Todos os direitos reservados.",
          en: "All rights reserved.",
        })
      }}
    </p>
  </div>
</template>

<script lang="ts">
import { useThemeStore } from "@/store/theme";
import { getFileUrl } from "@/utils/generics.util";
import { defineComponent, ref, watch } from "vue";

export default defineComponent({
  name: "footerComponent",
  computed: {
    todayYear(): number {
      let today = new Date();
      return today.getFullYear();
    },
  },
  setup() {
    const storeTheme = useThemeStore;
    const partners = ref(storeTheme.partners);
    watch(storeTheme, (val) => (partners.value = val.partners));

    return { storeTheme, partners, getFileUrl };
  },
});
</script>

<style lang="scss">
#partners-imgs-footer {
  width: fit-content;
  height: 80px;
}
</style>
